// API Configuration
// This file centralizes API URL configuration for the entire application

export const API_URL = process.env.REACT_APP_API_URL || 'https://api.cosmiwork.com/api';
export const API_BASE_URL = API_URL;

// Socket.IO server URL (without /api path)
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'https://api.cosmiwork.com';

export default API_URL;
